import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'shortDisplayValue'
})
export class ShortDisplayValuePipe implements PipeTransform {

  transform(value: number, fixed: boolean = true, minValue: number = 500, symbol?: string): string {
    const shortValue = this.shortValue(value, fixed, minValue, symbol);
    return shortValue;
  }

  private shortValue(value: number, fixed: boolean = true, minValue: number = 500, symbol?: string): string {
    const symbolString = symbol || '';

    if (value < minValue) {
      return this.shortValue(minValue, fixed, 0, `<${symbolString}`);
    }

    if (value >= 1_000_000_000_000_000) {
      const v = value / 1_000_000_000_000_000;
      return `${symbolString}${fixed ? (v % 1 ? v.toFixed(1) : v.toFixed(0)) : v}Q`;
    }

    if (value >= 1_000_000_000_000) {
      const v = value / 1_000_000_000_000;
      return `${symbolString}${fixed ? (v % 1 ? v.toFixed(1) : v.toFixed(0)) : v}T`;
    }

    if (value >= 1_000_000_000) {
      const v = value / 1_000_000_000;
      return `${symbolString}${fixed ? (v % 1 ? v.toFixed(1) : v.toFixed(0)) : v}B`;
    }
    if (value >= 1_000_000) {
      const v = value / 1_000_000;
      return `${symbolString}${fixed ? (v % 1 ? v.toFixed(1) : v.toFixed(0)) : v}M`;
    }
    if (value >= 1_000) {
      const v = value / 1_000;
      return `${symbolString}${fixed ? (v % 1 ? v.toFixed(1) : v.toFixed(0)) : v}K`;
    }

    return `${symbolString}${value}`;
  }

}
